import { makeMultiSearch, makeSearch } from "../../UI/Search/Search";
import StageService from "../../../Services/Stage.service";
const makeSearchArgs = {
    loadOptions: (search, options) => {
        return StageService.search(Object.assign(Object.assign({}, options), { query: search })).then(({ data }) => data);
    },
    label: "name",
    value: "id",
};
const makeSearchArgsExtendedName = {
    loadOptions: (search, options) => {
        return StageService.search(Object.assign(Object.assign({}, options), { query: search })).then(({ data }) => {
            return data.map((stage) => {
                return Object.assign(Object.assign({}, stage), { name: `${stage.name} (${stage.pipeline.name})` });
            });
        });
    },
    label: "name",
    value: "id",
};
export const StageSearch = makeSearch(makeSearchArgs);
export const StageMultiSearch = makeMultiSearch(makeSearchArgs);
export const StageExtendedNameMultiSearch = makeMultiSearch(makeSearchArgsExtendedName);
